import React from "react";
import { TableBody } from "@mui/material";
import UsersTableRow from "./UsersTableRow";
import { ManagedUser } from "./userDisplayUtils";

interface UsersTableUserMapProps {
    users: ManagedUser[];
    onEdit: (user: ManagedUser) => void;
    onDelete: (user: ManagedUser) => void;
    roleBasedOptions: string[];
    isBuyer?: boolean;
}

const UsersTableUserMap = ({ users, onEdit, onDelete, roleBasedOptions, isBuyer }: UsersTableUserMapProps) => {
    return <TableBody>
        {
            users.map((user) => {
                return (
                    <UsersTableRow
                        key={user.username}
                        user={user}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        roleBasedOptions={roleBasedOptions}
                        isBuyer={isBuyer}
                    />
                )
            }
        ) }
        </TableBody>

};
export default UsersTableUserMap;
